<template>
  <i class="material-icons"
     v-on="$listeners"
     :style="iconStyle">
    {{ content }}
  </i>
</template>

<script>
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'IconBookmark',
    props: {
      disabled: { type: Boolean, required: false, default: false },
      marked: { type: Boolean, required: false, default: false },
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      content: function () {
        return this.marked ? 'bookmark' : 'bookmark_outline';
      },
      iconStyle: function () {
        return {
          color: this.disabled ? this.color.dark4() : this.color.dark3(),
          cursor: this.disabled ? 'not-allowed' : 'pointer',
          fontSize: FontStyle.size.md,
        };
      },
    },
  };
</script>
